import { TFunction } from "i18next";
import * as yup from "yup";
import { TUploadedFile } from "~/client/http/FileController";
import { MALUS_STATUS } from "~/entity/Appeals/model/schema";
import { ISelectOption } from "~/shared/ui/Fields/types";
import { FormField, IFormGenConfig } from "~/widgets/FormGen/model/schema";
import { IAppealSendForm } from "~/widgets/Modals/AddAppeal/model/schema";

interface IGetFormConfigToSendProps {
  scope: "appeal" | "resolution" | "editor";
  translateFunc: TFunction;
  contactsSelectOptionsList: ISelectOption[];
  fileFieldWrapperClassName?: string;
  fileList: TUploadedFile[];
}

const malusStatusOptions = [
  { label: "Да", value: MALUS_STATUS.false },
  { label: "Нет", value: MALUS_STATUS.true },
];

export const getFormConfigToSendAppeal = ({
  scope,
  translateFunc,
  contactsSelectOptionsList,
  fileFieldWrapperClassName,
  fileList,
}: IGetFormConfigToSendProps): IFormGenConfig<IAppealSendForm> => {
  const resolveFiledByMode = () => {
    return [
      ...(scope === "appeal"
        ? [
            {
              type: "select",
              name: "contactPersonId",
              label: "Контактное лицо*",
              span: 1,
              props: {
                options: contactsSelectOptionsList,
              },
            },
          ]
        : [
            {
              type: "select",
              name: "status",
              label: "Малус*",
              span: 1,
              props: {
                options: malusStatusOptions,
              },
            },
          ]),
    ] as FormField<IAppealSendForm>[];
  };

  return {
    schema: yup.object().shape({
      ...(scope === "appeal"
        ? {
            contactPersonId: yup.object().shape({
              label: yup
                .string()
                .min(1, translateFunc("validation.more250"))
                .required(translateFunc("validation.required")),
              value: yup
                .number()
                .nullable()
                .required(translateFunc("validation.required")),
            }),
          }
        : {}),
      ...(scope === "resolution"
        ? {
            status: yup.object().shape({
              label: yup
                .string()
                .min(1, translateFunc("validation.more250"))
                .required(translateFunc("validation.required")),
              value: yup
                .mixed()
                .nullable()
                .required(translateFunc("validation.required")),
            }),
          }
        : {}),
      // comment: yup
      //   .string()
      //   .trim()
      //   .required(translateFunc("validation.required")),
    }),
    layout: { columns: 1, gap: 10 },
    fields: [
      ...resolveFiledByMode(),
      {
        type: "textarea",
        name: "comment",
        label: "Введите комментарий",
        span: 1,
        props: {
          fullWidth: true,
        },
      },
      {
        type: "file",
        name: "fileIds",
        wrapperClassName: fileFieldWrapperClassName,
        props: {
          fileList: fileList,
          accept: ["application/pdf", ".pdf"],
          maxSizeMb: 2,
        },
      },
    ],
  };
};
